const brand = {
  name: "FTD",
  short: "FTD",
  domain: "ftd-consultancy.com",
  tagline: "Software shaped to the business.",
  oneLiner:
    "FTD is an engineering studio that designs and builds custom software where the off-the-shelf stack runs out of road.",
  pitch:
    "We are a small, senior engineering team. We design and build the systems that operators run on — back-offices, integration layers between ERP and CRM, custom logistics platforms, mobile applications and the cloud platforms that hold them up. Engaged on retainer or fixed scope, the code is delivered to the client, and what we build is finished to spec.",
  contact: {
    email: "info@ftd-consultancy.com",
    finance: "finance@ftd-consultancy.com",
    hours: "Mon — Fri · 09:00 — 18:00 EET",
  },
  hq: {
    city: "Sofia",
    country: "Bulgaria",
    address: {
      line1: "9 Pozitano Street",
      line2: "Triaditsa District · Sofia 1000, Bulgaria",
    },
    timezone: "EET",
  },
  numbers: [
    { v: "5+",   l: "Years average lifetime of systems still in production" },
    { v: "100%", l: "Code delivered to the client — no rent-seeking" },
    { v: "9",    l: "Sectors covered across active engagements" },
    { v: "0",    l: "Junior pass-through on engagement leadership" },
  ],
};

export default brand;
